import { Lock, ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { privacy } from "../i18n/privacy";
import { FOUNDER_PATHS, founder } from "../i18n/founder";

export const Disclaimer = () => {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="disclaimer-section" className="relative border-t border-white/5 bg-ink px-6 pb-[max(2.5rem,env(safe-area-inset-bottom))] pt-16 sm:px-8">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/30 bg-gold/10">
              <ShieldAlert className="h-4 w-4 text-gold" />
            </span>
            <h3 className="font-mono text-[12px] uppercase tracking-[0.3em] text-zinc-300" data-testid="disclaimer-title">{t.disclaimer.title}</h3>
          </div>
          <div className="mt-6 space-y-4" data-testid="disclaimer-text">
            {t.disclaimer.body.map((p) => (
              <p key={p.slice(0, 24)} className="text-[13px] leading-relaxed text-zinc-400">{p}</p>
            ))}
          </div>
        </Reveal>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row">
          <span className="font-display text-sm font-bold text-zinc-200">
            SYN<span className="font-serif text-[1.15em] font-normal italic text-gold">rise</span>
          </span>
          <span className="font-mono text-[12px] text-zinc-400" data-testid="footer-copyright">© {year} SYNrise. {t.disclaimer.rights}</span>
        </div>
        <div className="mt-6 flex items-center justify-center gap-2">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="rounded-full px-3 py-1.5 font-mono text-[12px] text-zinc-400 transition-colors hover:text-gold">
            {privacy[lang].label}
          </Link>
          <span className="text-zinc-600" aria-hidden="true">·</span>
          <Link to={FOUNDER_PATHS[lang]} data-testid="footer-founder-link" className="rounded-full px-3 py-1.5 font-mono text-[12px] text-zinc-400 transition-colors hover:text-gold">
            {founder[lang].footerLink}
          </Link>
          <span className="text-zinc-600" aria-hidden="true">·</span>
          <Link to="/admin" data-testid="footer-admin-link" className="flex items-center gap-1.5 rounded-full px-3 py-1.5 font-mono text-[12px] text-zinc-400 transition-colors hover:text-gold">
            <Lock className="h-3 w-3" /> Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
